export default __webpack_public_path__ + "static/media/webpackLogo.47692505.png";